import styled, { css } from 'styled-components'

import { mediaMaxMobile } from '@root/shared/ui-kit/theme'

import type { ChildrenProps, ClassNameProps } from '@root/shared/react'

type SplashPointsCardProps = {} & ClassNameProps & ChildrenProps

export const SplashPointsCard: React.FC<SplashPointsCardProps> = ({
  className,
  children,
}) => <Root className={className}>{children}</Root>

const Root = styled.div`
  padding-block: 18px 16px;
  padding-inline: 32px;

  border-radius: 10px;
  border: 1px solid var(--backgroundA-3, rgba(255, 255, 255, 0.07));
  background: var(--backgroundA-3, rgba(255, 255, 255, 0.07));

  ${mediaMaxMobile(css`
    padding-block: 12px;
    padding-inline: 18px;
  `)}
`
